import React, { useState } from 'react';
import { Card, Button, Radio, Space, Typography, Flex } from 'antd';
import { UserOutlined, EnvironmentOutlined, CheckCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const ModeSelector = ({ onModeSelect }) => {
    const [selectedMode, setSelectedMode] = useState(null);

    const modes = [
        {
            id: 1,
            name: 'Администратор',
            description: 'Полный доступ ко всем функциям системы',
            icon: <UserOutlined />
        },
        {
            id: 2,
            name: 'Садовник',
            description: 'Доступ к функциям ухода за растениями',
            icon: <EnvironmentOutlined />
        }
    ];

    const handleSelect = (modeId) => {
        setSelectedMode(modeId);
    };

    const handleConfirm = () => {
        if (selectedMode && onModeSelect) {
            onModeSelect(selectedMode);
        }
    };

    return (
        <div style={{ maxWidth: 500, margin: '40px auto', padding: '20px' }}>
            <Card>
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <div style={{ textAlign: 'center' }}>
                        <Title level={2}>Выберите режим работы</Title>
                        <Text type="secondary">Выберите подходящий режим для ваших задач</Text>
                    </div>

                    <Radio.Group value={selectedMode} style={{ width: '100%' }}>
                        <Space direction="vertical" style={{ width: '100%' }} size="middle">
                            {modes.map((mode) => (
                                <Radio key={mode.id} value={mode.id} style={{ width: '100%' }}>
                                    <Card
                                        size="small"
                                        style={{
                                            border: selectedMode === mode.id ? '2px solid #1890ff' : '1px solid #d9d9d9',
                                            width: '100%',
                                            cursor: 'pointer',
                                            backgroundColor: selectedMode === mode.id ? '#f0f8ff' : 'white'
                                        }}
                                        onClick={() => handleSelect(mode.id)}
                                    >
                                        <Flex align="center" gap="middle">
                                            <div style={{ fontSize: '24px', color: selectedMode === mode.id ? '#1890ff' : '#00000073' }}>
                                                {mode.icon}
                                            </div>

                                            <div style={{ flex: 1 }}>
                                                <Title level={5} style={{ margin: 0, display: 'flex', alignItems: 'center' }}>
                                                    {mode.name}
                                                    {selectedMode === mode.id && (
                                                        <CheckCircleOutlined
                                                            style={{
                                                                color: '#52c41a',
                                                                marginLeft: '8px',
                                                                fontSize: '16px'
                                                            }}
                                                        />
                                                    )}
                                                </Title>
                                                <Text type="secondary">{mode.description}</Text>
                                            </div>
                                        </Flex>
                                    </Card>
                                </Radio>
                            ))}
                        </Space>
                    </Radio.Group>

                    <Button
                        type="primary"
                        size="large"
                        onClick={handleConfirm}
                        disabled={!selectedMode}
                        block
                    >
                        {selectedMode
                            ? `Перейти в режим "${modes.find(m => m.id === selectedMode)?.name}"`
                            : 'Выберите режим для продолжения'
                        }
                    </Button>
                </Space>
            </Card>
        </div>
    );
};

export default ModeSelector;